// /src/components/layout/Layout/NullLayout.jsx

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

export default function NullLayout() {
  return (
    <Box>
      <Outlet />
    </Box>
  );
}